import * as React from 'react';
import { SVGProps } from 'react';

const IconQuestionSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10zm-.934-6.429H3.857c0-1.285.917-2.142 2.286-2.142 1.275 0 2.143.818 2.143 1.928 0 .721-.3 1.244-.929 1.643-.593.37-.828.534-.828.995l.035.434H5.386l-.05-.444c-.058-.769.263-1.167.878-1.556.576-.37.715-.553.715-1 0-.496-.363-.847-.929-.847-.566 0-.908.46-.934.99zm1.726 4.32c0 .505-.308.817-.808.817s-.811-.312-.811-.817c0-.51.312-.822.811-.822.5 0 .808.312.808.822z"
    />
  </svg>
);
export default IconQuestionSizeXs;
